/* unplugin-vue-components disabled */import { render } from "./text-area.vue?vue&type=template&id=9c671aa6&scoped=true"
import script from "./text-area.vue?vue&type=script&lang=js"
export * from "./text-area.vue?vue&type=script&lang=js"

import "./text-area.vue?vue&type=style&index=0&id=9c671aa6&scoped=true&lang=stylus"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c671aa6"],['__file',"src/controls/text-area.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9c671aa6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9c671aa6', __exports__)) {
    api.reload('9c671aa6', __exports__)
  }
  
  module.hot.accept("./text-area.vue?vue&type=template&id=9c671aa6&scoped=true", () => {
    api.rerender('9c671aa6', render)
  })

}


export default __exports__